import dispatcher from "../dispatcher"
import * as hierarchyHelper from "../helpers/hierarchyHelper"
import { IHierarchyItem } from "../models"

export function receiveHierarchyGlobalItem(item: IHierarchyItem) {
    dispatcher.dispatch({
        type: "RECEIVE_GLOBAL_HIERARCHY_SELECTED_ITEM",
        object: item
    })
}

export function receiveHierarchyGlobalItemId(itemId: string) {
    receiveHierarchyGlobalItem(hierarchyHelper.getHierarchyItemById(itemId))
}

export function receiveHierarchySelectedItem(item: IHierarchyItem) {
    dispatcher.dispatch({
        type: "RECEIVE_HIERARCHY_SELECTED_ITEM",
        object: item
    })
}